import BackButton from '@/components/back-button';
import ContentLayout from '@/components/layout/ContentLayout';
import { QuizCarousel } from '@/components/quiz-carousel';
import { useAuth } from '@/contexts/AuthContext';
import { getQuestionList } from '@/services/generatedAPIs';
import { GetQuestionListResponse } from '@/services/generatedAPIs.schemas';
import React, { useEffect } from 'react';
import { LoadingOverlay } from '@/components/ui/loading-overlay';
import { ROUTE } from '@/routes/constants';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

type StudentViewState = {
  assignmentId: number;
  studentId: number;
}

const StudentViewPageInner = ({ state }: { state: StudentViewState }) => {
    const {t, i18n} = useTranslation();
    const { getCurrentUser } = useAuth();
    const [questionListResponse, setQuestionListResponse] = React.useState<GetQuestionListResponse>();

    React.useEffect(() => {
       getQuestionList({ assignmentId: state.assignmentId, studentId: state.studentId, newest: true }).then((rsp) => {
            if (!questionListResponse && rsp.code === 200 && rsp.data) {
              setQuestionListResponse(rsp.data);
            } else {
              console.log('Error getQuestionList', rsp)
            }
        }).catch((e) => {
          console.log('Error getQuestionList', e)
        });
    }, []);

    return (
        <ContentLayout title={t("teacher.studentview")}>
            <div className="mx-auto space-y-6">
                <div className="bg-white shadow-md rounded-lg m-2 p-6">
                   <div className="mb-4">
                     <BackButton />
                   </div>
                   { questionListResponse && <QuizCarousel quizProps={questionListResponse} readonly={true}></QuizCarousel> }
                </div>
            </div>
        </ContentLayout>
    );
};

const StudentViewPage = () => {
  const state = useLocation().state as StudentViewState | null;
  const navigate = useNavigate();

  const isValidState = (s: any): s is StudentViewState => {
    return !!s && typeof s.assignmentId === 'number' && typeof s.studentId === 'number';
  };

  useEffect(() => {
    if (!isValidState(state)) {
      navigate(ROUTE.TEACHER.HOMEWORK_OVERVIEW, { replace: true });
    }
  }, [state, navigate]);

  if (!isValidState(state)) {
    return <LoadingOverlay />;
  }

  return <StudentViewPageInner state={state} />;
};

export default StudentViewPage;